import React from 'react';
import chroma from 'chroma-js';
import { InputContainer, NoArrowNumberInput } from './styles';

interface HslColor {
  hue: number;
  saturation: number;
  lightness: number;
}

interface ControllerProps {
  value: string;
  onChange(code: HslColor): void;
  hueOnly?: boolean;
}

export const HslController: React.FC<ControllerProps> = ({ value, onChange, hueOnly }) => {
  const hsl_value: HslColor = (() => {
    try {
      const [h, s, l] = chroma(value).hsl();
      return { hue: h, saturation: s, lightness: l };
    } catch (e) {
      return { hue: 0, saturation: 0, lightness: 0 };
    }
  })();
  const setHslValue = (value: number, type: keyof HslColor) => {
    onChange({ ...(hsl_value as HslColor), [type]: value });
  };

  return (
    <InputContainer>
      <NoArrowNumberInput
        value={Math.round(hsl_value?.hue)}
        onChange={(event) => setHslValue(Math.min(360, Number(event.target.value)), 'hue')}
        maxLength={3}
        data-testid='color-picker-controller-hsl-h-input'
      />
      <NoArrowNumberInput
        value={Math.round(hsl_value?.saturation * 100)}
        onChange={(event) => setHslValue(Math.min(100, Number(event.target.value)) / 100, 'saturation')}
        maxLength={3}
        disabled={hueOnly}
        data-testid='color-picker-controller-hsl-s-input'
      />
      <NoArrowNumberInput
        value={Math.round(hsl_value?.lightness * 100)}
        onChange={(event) => setHslValue(Math.min(100, Number(event.target.value)) / 100, 'lightness')}
        maxLength={3}
        disabled={hueOnly}
        data-testid='color-picker-controller-hsl-l-input'
      />
    </InputContainer>
  );
};
